import Vue from '../../../../lib/utils/vue'
import VueI18n from 'vue-i18n'
import * as getters from '../../../../../builder/src/js/store/modules/getters'
import * as constants from '../../../../../builder/src/js/common/constants/constants'
import { mapGetters, mapState } from 'vuex'
import {
  getIntegrationTitle,
  getIntegrationUseSubtext,
  getIntegrationUseWrap,
  IntegrationDescription
} from "../description";
import { IntegrationLogoWrapper } from '../logo-wrapper'
import { IntegrationContainer } from '../container'
import { EmailSetup } from "./setup";
import IntegrationItemBase from "../IntegrationItemBase.vue";

Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

export default IntegrationItemBase.extend({
  name: 'EmailIntegration',
  data() {
    return {}
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
    }),
  },
  created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors
  },
  mounted() {
    this.onScrollInToView()
  },
  methods: {
    onScrollInToView() {
      const container = document.getElementById('authWrap')
      container?.scrollIntoView()
    },
  },
  render: function (h) {
    const integrationTitle = this.selectedIntegration.title

    const IntegrationTitle = getIntegrationTitle()
    const IntegrationUseWrap = getIntegrationUseWrap()
    const IntegrationUseSubtext = getIntegrationUseSubtext()

    return (
      <IntegrationContainer>
        {this.showAuthScreen && (
          <IntegrationLogoWrapper>
            <IntegrationDescription skipAuth={true}
                                    authenticationText="continue"
                                    provider="email"
                                    onStepChange={(step) => this.onChangeAuthStep(step, this.selected.id)}>
              <div style="padding: 45px 0px 45px 45px;">
                <IntegrationTitle>
                  The <strong>Email</strong> integration allows you to receive form submissions
                  directly in your email inbox. When a visitor submits a form on your page,
                  the submission data will be automatically sent to the email address you configure.
                </IntegrationTitle>
                <IntegrationUseWrap>
                  <p>Use this integration to</p>
                  <ul>
                    <li>
                      Receive instant email notifications when a form is submitted
                    </li>
                    <li>
                      Get all form field data delivered straight to your inbox
                    </li>
                    <li>
                      Stay on top of new leads without needing a third-party CRM
                    </li>
                  </ul>
                </IntegrationUseWrap>
                <IntegrationUseSubtext>
                  Simply enter the email address where you'd like to receive form submissions
                  and send a test email to verify delivery. It's the quickest way to start
                  capturing leads from your forms.
                </IntegrationUseSubtext>
              </div>
            </IntegrationDescription>
          </IntegrationLogoWrapper>
        )}

        {this.integrationConfig.step === constants.AUTH_SUCCESS && this.isValidProvider && (
          <EmailSetup onCompleted={() => this.onFinished()} onCancel={this.onCancel}/>
        )}
        {this.integrationConfig.step === constants.INTEGRATION_FINISHED && this.isValidProvider && (
          <EmailSetup onCancel={this.onCancel} onCompleted={() => this.onFinished()}/>
        )}
      </IntegrationContainer>
    )
  },
})
